<div class="col-xl">
    <form [formGroup]="driverForm" id="formDriver" (ngSubmit)="addDriver()">
        <div class="card mb-4">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h5 class="mb-0">Datos Personales</h5>
            </div>
            <div class="card-body">
                <div class="mb-3">
                    <div class="row">
                        <div class="col-lg-4 col-lg-4 col-xs-12">
                            <label class="form-label" for="basic-default-company">Nombre*</label>
                            <div class="input-group input-group-merge">
                                <input type="text" class="form-control" id="basic-default-company" [(ngModel)]="formModelData.name" [ngClass]="driverForm.controls['name'].errors  && !driverForm.controls['name'].pristine ? 'is-invalid' : ''"
                                    formControlName="name">
                                <div class="invalid-feedback" *ngIf="driverForm.controls['name'].errors  && !driverForm.controls['name'].pristine">
                                    El campo nombre es obligatorio
                                </div>
                            </div>
                            
                        </div>
                        <div class="col-lg-4 col-lg-4 col-xs-12">
                            <label class="form-label" for="basic-default-company">Apellido*</label>
                            <div class="input-group input-group-merge">
                                <input type="text" class="form-control" id="basic-default-company" [(ngModel)]="formModelData.last_name" [ngClass]="driverForm.controls['last_name'].errors  && !driverForm.controls['last_name'].pristine ? 'is-invalid' : ''"
                                formControlName="last_name">
                                <div class="invalid-feedback" *ngIf="driverForm.controls['last_name'].errors  && !driverForm.controls['last_name'].pristine">
                                    El campo apellido es obligatorio
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <label class="form-label" for="basic-default-company">RFC*</label>
                            <div class="input-group input-group-merge">
                                <input type="text" class="form-control" id="basic-default-company" [(ngModel)]="formModelData.rfc_figura" [ngClass]="driverForm.controls['rfc_figura'].errors  && !driverForm.controls['rfc_figura'].pristine ? 'is-invalid' : ''"
                                formControlName="rfc_figura">
                                <div class="invalid-feedback" *ngIf="driverForm.controls['rfc_figura'].errors  && !driverForm.controls['rfc_figura'].pristine">
                                    El campo RFC es obligatorio
                                </div>
                            </div>
                            
                        </div>
                        <div class="col">
                            <label class="form-label" for="basic-default-company">Num. de Licencia*</label>
                            <div class="input-group input-group-merge">
                                <input type="text" class="form-control" id="basic-default-company" [(ngModel)]="formModelData.num_licencia" [ngClass]="driverForm.controls['num_licencia'].errors  && !driverForm.controls['num_licencia'].pristine ? 'is-invalid' : ''"
                                formControlName="num_licencia">
                                <div class="invalid-feedback" *ngIf="driverForm.controls['num_licencia'].errors  && !driverForm.controls['num_licencia'].pristine">
                                    El campo num. de licencia es obligatorio
                                </div>
                            </div>
                            
                        </div>
                        <div class="col-lg-4 col-lg-4 col-xs-12">
                            <label class="form-label" for="basic-default-company">Celular*</label>
                            <div class="input-group input-group-merge">
                                <input type="text" class="form-control" id="basic-default-company" [(ngModel)]="formModelData.cell_phone" [ngClass]="driverForm.controls['cell_phone'].errors  && !driverForm.controls['cell_phone'].pristine ? 'is-invalid' : ''"
                                    formControlName="cell_phone">
                                <div class="invalid-feedback" *ngIf="driverForm.controls['cell_phone'].errors  && !driverForm.controls['cell_phone'].pristine">
                                    El campo celular es obligatorio
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
                <div class="mb-3">
                    <div class="row">
                        <div class="col-lg-6 col-xs-12">
                            <label class="form-label" for="basic-default-company">Fecha Nacimiento*</label>
                            <div class="input-group input-group-merge">
                                <input type="date" class="form-control" id="basic-default-company" [(ngModel)]="formModelData.birthday_date" [ngClass]="driverForm.controls['birthday_date'].errors  && !driverForm.controls['birthday_date'].pristine ? 'is-invalid' : ''"
                                    formControlName="birthday_date">
                                <div class="invalid-feedback" *ngIf="driverForm.controls['birthday_date'].errors  && !driverForm.controls['birthday_date'].pristine">
                                    El campo fecha de nacimiento es obligatorio
                                </div>
                            </div>
                            
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <label class="form-label" for="basic-default-company">Alcaldia o Municipio*</label>
                            <div class="input-group input-group-merge">
                                <input type="text" class="form-control" id="basic-default-company" [(ngModel)]="formModelData.municipality" [ngClass]="driverForm.controls['municipality'].errors  && !driverForm.controls['municipality'].pristine ? 'is-invalid' : ''"
                                    formControlName="municipality">
                                <div class="invalid-feedback" *ngIf="driverForm.controls['municipality'].errors  && !driverForm.controls['municipality'].pristine">
                                    El campo alcaldia o municipio es obligatorio
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card mb-4">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h5 class="mb-0">Datos Bancarios</h5>
            </div>
            <div class="card-body">
                <div class="mb-3">
                    <div class="row">
                        <div class="col-lg-4 col-lg-4 col-xs-12">
                            <label class="form-label" for="basic-default-company">Nombre del Titular*</label>
                            <div class="input-group input-group-merge">
                                <input type="text" class="form-control" id="basic-default-company" [(ngModel)]="formModelData.bank_data.holder_name" [ngClass]="driverForm.controls['bank_holder_name'].errors  && !driverForm.controls['bank_holder_name'].pristine ? 'is-invalid' : ''"
                                    formControlName="bank_holder_name">
                                <div class="invalid-feedback" *ngIf="driverForm.controls['bank_holder_name'].errors  && !driverForm.controls['bank_holder_name'].pristine">
                                    El campo nombre del titular es obligatorio
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-lg-4 col-xs-12">
                            <label class="form-label" for="basic-default-company">Banco*</label>
                            <div class="input-group input-group-merge">
                                <input type="text" class="form-control" id="basic-default-company" [(ngModel)]="formModelData.bank_data.bank_name" [ngClass]="driverForm.controls['bank_name'].errors  && !driverForm.controls['bank_name'].pristine ? 'is-invalid' : ''"
                                formControlName="bank_name">
                                <div class="invalid-feedback" *ngIf="driverForm.controls['bank_name'].errors  && !driverForm.controls['bank_name'].pristine">
                                    El campo nombre del titular es obligatorio
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-lg-4 col-xs-12">
                            <label class="form-label" for="basic-default-company">Numero de Cuenta o Tarjeta*</label>
                            <div class="input-group input-group-merge">
                                <input type="text" class="form-control" id="basic-default-company" [(ngModel)]="formModelData.bank_data.account_number" [ngClass]="driverForm.controls['bank_account_number'].errors  && !driverForm.controls['bank_account_number'].pristine ? 'is-invalid' : ''"
                                    formControlName="bank_account_number">
                                <div class="invalid-feedback" *ngIf="driverForm.controls['bank_account_number'].errors  && !driverForm.controls['bank_account_number'].pristine">
                                    El campo numero de cuenta o tareta es obligatorio
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
                <div class="mb-3">
                    <div class="row">
                        <div class="col-lg-12 col-xs-12">
                            <label class="form-label" for="basic-default-company">Tipo de Cuenta*</label>
                            <div class="input-group input-group-merge">
                                <input type="text" class="form-control" id="basic-default-company" [(ngModel)]="formModelData.bank_data.account_type" [ngClass]="driverForm.controls['bank_account_type'].errors  && !driverForm.controls['bank_account_type'].pristine ? 'is-invalid' : ''"
                                    formControlName="bank_account_type">
                                <div class="invalid-feedback" *ngIf="driverForm.controls['bank_account_type'].errors  && !driverForm.controls['bank_account_type'].pristine">
                                    Ingrese el nombre de cliente
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card mb-4">
            <div class="card-body text-center">
                <button type="submit" class="btn btn-primary me-sm-3 me-1">Guardar Conductor</button>
            </div>
        </div>
    </form>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" size="medium" color="#fff" type="ball-atom">
    <div class="loader"></div>
    <p style="font-size: 20px; color: white">Espere un momento...</p>
</ngx-spinner>